module.exports = __webpack_public_path__ + "img/content-1.1eb96a9d.png";